module.exports = __webpack_public_path__ + "static/OP11-10830e4c254cfcdd5af811cd6ec1be86.jpg";